/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ id: NonNullable<unknown> }} Ateliere_Connect_Status_Video_DetailsInputs */



/**
* | output |
* | --- |
* | "Getting details for video file: {id}..." |
*
* @param {Ateliere_Connect_Status_Video_DetailsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_status_video_details = /** @type {((inputs: Ateliere_Connect_Status_Video_DetailsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Status_Video_DetailsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Récupération des détails du fichier vidéo : ${i?.id}...`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Details zur Videodatei werden abgerufen: ${i?.id}...`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Ottenimento dei dettagli per il file video: ${i?.id}...`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Получение информации о видеофайле: ${i?.id}...`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Obteniendo detalles del archivo de vídeo: ${i?.id}...`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`正在获取视频文件${i?.id}的详细信息...`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ビデオファイルの詳細を取得しています: ${i?.id}...`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`वीडियो फ़ाइल ${i?.id} के लिए विवरण प्राप्त किए जा रहे हैं...`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Obtendo detalhes do arquivo de vídeo: ${i?.id}...`)
	return /** @type {LocalizedString} */ (`Getting details for video file: ${i?.id}...`)
});